import React, { useRef, useState } from "react";
import { toast } from "react-toastify";

import Modal from "../../../components/Modal";
import Button from "../../../components/Button";
import Icon from "../../../components/Icon";

import api from "../../../services/api";
import { renderError } from "../../../helpers/errors";

// Importação do extrato OFX na conta selecionada.
export const ModalImport = ({ show, close, bankAccount, onImported }) => {
    const [file, setFile] = useState(null);
    const [importing, setImporting] = useState(false);

    const inputRef = useRef();

    const reset = () => {
        setFile(null);
        setImporting(false);
    };

    const handleClose = () => {
        reset();
        close();
    };

    const send = () => {
        setImporting(true);

        const formData = new FormData();
        formData.append('finance_bank_account_id', bankAccount.id);
        formData.append('file', file);

        api.post(`/finance-reconciliation/import`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
            const { imported_count: imported, duplicated_count: duplicated } = res.data.resource;

            toast.success(
                duplicated > 0
                    ? `${imported} lançamentos importados · ${duplicated} já estavam no sistema`
                    : `${imported} lançamentos importados`
            );

            reset();
            close();
            onImported();
        }).catch(renderError).then(() => setImporting(false));
    };

    return (
        <Modal
            title={`Importar extrato`}
            show={show}
            close={handleClose}
            footer={
                <>
                    <Button type={`secondary`} size={`small`} text={`Cancelar`} action={handleClose} />
                    <Button type={`primary`} size={`small`} text={`Importar`} action={send} loading={importing} disabled={!file} />
                </>
            }
        >
            <div className="section finance-import-ofx">
                <p className={`import-hint`}>
                    Baixe o extrato no internet banking em formato <strong>OFX</strong> e envie aqui.
                    Lançamentos já importados antes são reconhecidos e não entram duas vezes.
                </p>

                <input
                    ref={inputRef}
                    type="file"
                    accept=".ofx,.OFX,.qfx"
                    style={{ display: 'none' }}
                    onChange={event => { setFile(event.target.files[0] ?? null); event.target.value = ''; }}
                />

                <button className={`import-drop`} onClick={() => inputRef.current?.click()}>
                    <Icon name={`upload`} />
                    <span>
                        <strong>{file ? file.name : 'Escolher arquivo OFX'}</strong>
                        <small>{bankAccount ? `Conta: ${bankAccount.name}` : ''}</small>
                    </span>
                </button>
            </div>
        </Modal>
    );
};

export default ModalImport;
